import { Box, Button, Typography } from '@mui/material'
import { SearchBar } from 'components/SearchBar/SearchBar'
import theme from 'lib/theme'
import React, { useState } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const PlacesHeader = ({
  handleSearch,
  handleOpenModal,
  query,
  hasListItems,
}: {
  handleSearch: (query?: string) => void
  handleOpenModal: () => void
  query: string | null
  hasListItems: boolean
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [input, setInput] = useState<string>('')

  const clearSearch = () => {
    setInput('')
    navigate('/place')
  }

  return (
    <Box>
      <Box
        display='flex'
        justifyContent='space-between'
        sx={{
          [theme.breakpoints.between('xs', 'sm')]: {
            flexDirection: 'column',
          },
        }}>
        <Typography variant='h1' mb={3}>
          {t('places')}
        </Typography>
        <Box
          sx={{
            [theme.breakpoints.up('sm')]: {
              display: 'flex',
            },
          }}>
          <SearchBar
            input={input}
            setInput={setInput}
            placeholderText={t('searchPlacesPlaceholder')}
            handleClick={handleSearch}
            ariaLabel={t('searchPlaces')}
          />
          <Button
            onClick={() => handleOpenModal()}
            sx={{
              minWidth: '144px',
              backgroundColor: theme.palette.neutral.grey9,
              color: theme.palette.text.primary,
              padding: theme.spacing(1),
              '&:hover': {
                backgroundColor: theme.palette.neutral.grey7,
              },
            }}>
            {t('createNewPlace')}
          </Button>
        </Box>
      </Box>
      {query && (
        <Box>
          <Box>
            <Button
              onClick={clearSearch}
              sx={{
                background: 'transparent',
                color: theme.palette.primary.main,
                padding: 0,
                marginBottom: theme.spacing(1),
                '&:hover': {
                  background: 'transparent',
                  color: theme.palette.primary.dark,
                },
              }}>
              <ArrowBackIcon
                sx={{
                  fill: theme.palette.primary.main,
                  marginRight: theme.spacing(1),
                  '&:hover': { fill: theme.palette.primary.dark },
                }}
              />
              <Typography>{t('allPlaces')}</Typography>
            </Button>
            {hasListItems ? (
              <Box display='flex'>
                <Typography
                  variant='h2'
                  sx={{ marginBottom: theme.spacing(1) }}>
                  {t('searchResults')}
                </Typography>
                <Typography variant='h2' sx={{ fontWeight: 'bold' }}>
                  &nbsp;&quot;{query}&quot;
                </Typography>
              </Box>
            ) : (
              <Box display='flex'>
                <Typography
                  variant='h2'
                  sx={{ marginBottom: theme.spacing(1) }}>
                  {t('noSearchResultWithQuery')}
                </Typography>
                <Typography variant='h2' sx={{ fontWeight: 'bold' }}>
                  &nbsp;&quot;{query}&quot;
                </Typography>
              </Box>
            )}
          </Box>
          {!hasListItems && (
            <Typography variant='body1'>{t('noSearchResults')}</Typography>
          )}
        </Box>
      )}
    </Box>
  )
}
